import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { filterDogs, resetShowDogs } from "../redux/actions";

import { usePages } from "./usePages";

export const useDogs = () => {
  const dispatch = useDispatch();
  const { showAllDogs } = useSelector((state) => state);

  const [loading, setLoading] = useState(true);
  const [showDogs, setShowDogs] = useState([]);
  const [change, setChange] = useState(false);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState([]);

  const { min, max, numPages, pagHandler, resetPages } = usePages({
    elemnt: showDogs,
  });

  const [dogs, setDogs] = useState(showDogs?.slice(min, max));
  //HANDLERS

  const orderHandler = (event) => {
    const { value } = event.target;
    if (value === "#") return;
    if (value === "ASC") {
      setShowDogs(showDogs.sort((a, b) => a.name.localeCompare(b.name)));
    }
    if (value === "DESC") {
      setShowDogs(
        showDogs.sort((a, b) => a.name.localeCompare(b.name)).reverse()
      );
    }
    if (value === "ASCW") {
      setShowDogs(
        showDogs.sort((a, b) => {
          if (a.weight.metric !== "NaN") {
            return (
              a.weight.metric.split(" - ")[0] - b.weight.metric.split(" - ")[0]
            );
          }
          return -1;
        })
      );
    }
    if (value === "DESCW") {
      setShowDogs(
        showDogs
          .sort((a, b) => {
            if (a.weight.metric !== "NaN") {
              return (
                a.weight.metric.split(" - ")[0] -
                b.weight.metric.split(" - ")[0]
              );
            }
            return -1;
          })
          .reverse()
      );
    }
    if (value === "ASCLF") {
      setShowDogs(
        showDogs.sort((a, b) => {
          return a.life_span.split(" - ")[0] - b.life_span.split(" - ")[0];
        })
      );
    }
    if (value === "DESCLF") {
      setShowDogs(
        showDogs
          .sort((a, b) => {
            return a.life_span.split(" - ")[0] - b.life_span.split(" - ")[0];
          })
          .reverse()
      );
    }
    event.target.value = "#";
    setChange(!change);
  };

  // FILTERS
  const tempHandler = (event) => {
    const temp = event.target.value;
    if (filters.includes(`Temp:${temp}`)) return;
    if (temp === "#") {
      setFilters([]);
      return dispatch(resetShowDogs());
    }
    if (temp === "$") return;
    dispatch(
      filterDogs(
        showDogs.filter((dog) => {
          if (isNaN(dog.id)) {
            return !!dog.Temperaments.find((temps) => temps.name === temp);
          }
          if (typeof dog.temperament !== "string") return false;
          return dog.temperament.includes(temp);
        })
      )
    );
    event.target.value = "$";
    setFilters([...filters, `Temp:${temp}`]);
    setLoading(true);
    setShowDogs([]);
    resetPages();
    setChange(!change);
  };
  const originFilterHandler = (event) => {
    const { value } = event.target;
    if (filters.includes(`Origin:${value}`)) return;
    if (value === "#") return;
    if (value === "DB") {
      setFilters([...filters, `Origin:${value}`]);
      dispatch(filterDogs(showDogs.filter((dog) => isNaN(dog.id))));
    }
    if (value === "API") {
      setFilters([...filters, `Origin:${value}`]);
      dispatch(filterDogs(showDogs.filter((dog) => !isNaN(dog.id))));
    }
    if (value === "ALL") {
      setFilters([]);
      dispatch(resetShowDogs());
    }
    event.target.value = "#";
    setShowDogs([]);
    setChange(!change);
    setLoading(true);
    resetPages();
  };

  const searchHandler = (e) => {
    setSearch(e.target.value);
  };
  const searchDispatch = () => {
    if (filters.includes(`Search:${search.toLowerCase()}`)) return;
    dispatch(
      filterDogs(
        showDogs.filter((dog) =>
          dog.name.toLowerCase().includes(search.toLowerCase())
        )
      )
    );
    setFilters([...filters, `Search:${search.toLowerCase()}`]);
    setLoading(true);
    setShowDogs([]);
    setSearch("");
    resetPages();
  };
  const searchClearHandler = () => {
    if (!filters.length) return;
    dispatch(resetShowDogs());
    setFilters([]);
    resetPages();
    setLoading(true);
    setShowDogs([]);
  };

  useEffect(() => {
    setShowDogs(showAllDogs);
  }, [showAllDogs, change]); //eslint-disable-line

  useEffect(() => {
    setDogs(showDogs.slice(min, max));
    if (showDogs.length) setLoading(false);
  }, [showDogs, change, numPages, min, max]);

  useEffect(() => {
    return setShowDogs([]);
  }, []);
  return {
    allPages: Math.ceil(showDogs.length / 8),
    dogs,
    loading,
    numPages,
    orderHandler,
    originFilterHandler,
    pagHandler,
    search,
    searchClearHandler,
    searchDispatch,
    searchHandler,
    showDogs,
    tempHandler,
    filters,
  };
};
